module.exports = __webpack_public_path__ + "img/nina.4956c5bc.png";